import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',

}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.statCounter.statApp.getDetail, {
        id,
    }, options);
    if (error) return { error, status };
    return content || {};
};
